import React, { useMemo } from 'react';
import { useHistory } from 'react-router';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Initials, Name, Email, CircleSpin, CloseButton, ChangeCompany } from './styles';

interface Props {
  name: string;
  email: string;
  onClose: () => void;
  companyName?: string;
  countryName?: string;
  countryCode?: string;
  hasCompanyBranches?: boolean;
  branchCompanyLogged?: boolean;
}

const RequesterProfile = ({
  name,
  email,
  onClose,
  companyName,
  countryName,
  countryCode,
  hasCompanyBranches,
  branchCompanyLogged,
}: Props) => {
  const initialsName = useMemo(() => {
    const splitted = name.split(' ');
    return `${splitted.first().slice(0, 1)}${splitted.last().slice(0, 1)}`;
  }, [name]);

  const history = useHistory();
  const { t } = useStoreTranslation();

  const handleCountrySelection = () => {
    history.push('/user-country-selection');
  };

  return (
    <Container>
      <Initials>
        {initialsName}
        <CircleSpin>
          <svg>
            <circle cx="50%" cy="50%" r="47px" />
          </svg>
        </CircleSpin>
      </Initials>
      <CloseButton src="/images/close.svg" onClick={onClose} />
      <Name>{name}</Name>
      <Email>{email}</Email>
      <Email>
        {companyName} / {countryName}
      </Email>
      {hasCompanyBranches && hasCompanyBranches === true && (
        <ChangeCompany onClick={handleCountrySelection}>{t('profileMenu.changeCompany')}</ChangeCompany>
      )}
    </Container>
  );
};

export default RequesterProfile;
